import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const ADIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="AD" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#FFD018"
        fillRule="evenodd"
        d="M4 0h8v12H4V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0h4v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E31D1C"
        fillRule="evenodd"
        d="M12 0h4v12h-4V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#BF9937"
        d="M8.542 2.276c.169-.11.38-.11.503.083.122.194-.026.393-.063.461-.037.068-.115.318.063.4.178.082.44.036.575-.082 0 0-.166-.075-.123-.197.043-.12.334-.462.868-.208.534.255.627.488.48.676-.146.189-.537.512-.443.73.003-.004.07-.117.16-.059.091.06.072.165.072.165s.65-.036.722.596c.07.62-.404.793-.422.8.003.002.155.172.053.282a.18.18 0 0 1-.22.044s-.214.202-.107.433c.107.232.185.3.185.3s.015-.071.142-.071.363.385.217.505c-.145.118-.215.098-.217.097.008.007.316.268.217.68-.1.416-.368.617-.643.734-.274.116-.602.116-1.023.116-.412 0-.66.25-.671.261.007.003.212.086.142.275-.07.188-.229.191-.234.191 0 0-.119.172-.233.115a1.196 1.196 0 0 1-.187-.115s-.096.19-.206.221v.007c-.005 0-.01-.003-.014-.004-.005 0-.01.004-.015.004v-.007c-.11-.032-.205-.22-.205-.22s-.072.056-.187.114c-.113.057-.232-.113-.233-.115 0 0-.163 0-.234-.191-.072-.192.142-.275.142-.275a.981.981 0 0 0-.67-.261c-.422 0-.75 0-1.025-.116-.275-.117-.542-.318-.642-.735-.098-.407.203-.667.216-.679-.006.002-.077.017-.216-.097-.146-.12.09-.504.216-.505.127 0 .143.071.143.071s.078-.068.185-.3c.105-.227-.1-.426-.107-.433a.18.18 0 0 1-.221-.044c-.103-.111.054-.282.054-.282-.008-.003-.494-.173-.423-.8.07-.623.704-.597.723-.596 0 0-.02-.105.072-.165.092-.06.16.06.16.06.094-.219-.297-.542-.443-.73-.147-.19-.055-.422.479-.677.534-.254.826.087.87.208.041.119-.117.193-.124.197a.587.587 0 0 0 .574.082c.179-.082.1-.332.063-.4-.037-.068-.185-.268-.063-.46.123-.194.335-.193.504-.084.145.094.35.143.407.156.056-.013.262-.062.407-.156Z"
      />
      <Path
        fill="#805440"
        d="m6.055 7.999.053-.127c.603.259 1.29.388 2.062.388.77 0 1.439-.13 2.006-.388l.055.126c-.585.267-1.273.4-2.061.4-.789 0-1.494-.133-2.115-.4Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
